/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/document';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrievePreliminaryNewYorkFinanceDisclosureDocumentRequest": {
                "fields": {}
              },
              "RetrievePreliminaryNewYorkFinanceDisclosureDocumentResponse": {
                "fields": {
                  "document": {
                    "type": ".squareup.corporate_card.resources.Document",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrievePreliminaryNewYorkFinanceDisclosureDocumentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrievePreliminaryNewYorkFinanceDisclosureDocumentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrievePreliminaryNewYorkFinanceDisclosureDocumentRequest @ squareup/corporate_card/service/retrieve_preliminary_new_york_finance_disclosure_document.proto at 9:1
 */
export const RetrievePreliminaryNewYorkFinanceDisclosureDocumentRequest = $root.lookupType('squareup.corporate_card.service.RetrievePreliminaryNewYorkFinanceDisclosureDocumentRequest');
fixType(RetrievePreliminaryNewYorkFinanceDisclosureDocumentRequest);
Builder.createAndAttachToType(RetrievePreliminaryNewYorkFinanceDisclosureDocumentRequest);
/**
 * SOURCE RetrievePreliminaryNewYorkFinanceDisclosureDocumentResponse @ squareup/corporate_card/service/retrieve_preliminary_new_york_finance_disclosure_document.proto at 15:1
 */
export const RetrievePreliminaryNewYorkFinanceDisclosureDocumentResponse = $root.lookupType('squareup.corporate_card.service.RetrievePreliminaryNewYorkFinanceDisclosureDocumentResponse');
fixType(RetrievePreliminaryNewYorkFinanceDisclosureDocumentResponse);
Builder.createAndAttachToType(RetrievePreliminaryNewYorkFinanceDisclosureDocumentResponse);